import { render, staticRenderFns } from "./backGroundImage.vue?vue&type=template&id=77b4d4c8"
import script from "./backGroundImage.vue?vue&type=script&lang=js"
export * from "./backGroundImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports